import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 40 41",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 41\" id=\"chevron-left\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24.53 29.53a.75.75 0 0 0 0-1.06l-8.293-8.293a.25.25 0 0 1 0-.354l8.293-8.293a.75.75 0 0 0-1.06-1.06l-8.293 8.292a1.75 1.75 0 0 0 0 2.475l8.293 8.293a.75.75 0 0 0 1.06 0Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol